// extracted by mini-css-extract-plugin
export default {"fullWordmark":"sqe-login-page_fullWordmark__TA21g","headingSqe":"sqe-login-page_headingSqe__RfDJh","headingLabs":"sqe-login-page_headingLabs__jsGw-"};